import { useContext } from 'react';
import { OnlineStatusContext } from 'src/react/_sw/OnlineStatusProvider/context';

export const useIsReadyForFetch = () => {
  const { isOnline, requestQueueLength } = useContext(OnlineStatusContext);

  // Don't fetch if there are pending requests in the Service Worker's offline queue: in this case, the API does not have the latest data.
  // Don't fetch if we're offline, as invalidating requests would otherwise cause warning messages to appear.
  return isOnline && requestQueueLength === 0;
};
